import objectMerge from 'object-merge';
import {LocalStorageService, Utilities } from 's2s-app-service';
import crypto from 'crypto-browserify';
import { addLocaleData } from 'react-intl';
import Messages from '../js/messages';
import LoggingService from 's2s-logging-service';

const app = (state, action)=>{
  if (typeof state === 'undefined') {
    let locale, dialect, messages, localeData;
    dialect = 'en';
    locale = dialect;
    messages = (new Messages(dialect)).getAllMessages();
    // inject onto utilities
    Utilities.getInstance().setIntlMessages(messages);
    // needed for INTL
    localeData = require('react-intl/locale-data/'+dialect);
    addLocaleData(localeData);

    return  {
              currentContact: undefined,
              'isSettingsOpen': false,
              'isSettingsPendingUpdate': false,
              'shouldSettingsStayOpen': false,
              'localeData': { locale, messages },
              'uiTheme': {appliedThemeName: 'default', appliedTheme: {}}
            };
  }
  LoggingService.getInstance().info('app ACTION CREATOR: ---- ', action.type );
  switch (action.type) {
    case 'APP_STATUS':
      LoggingService.getInstance().debug('APP REDUCER --- APP_STATUS');
      return { ...state, "status": objectMerge(state.status, action.payload)};

    case 'TOGGLE_SETTINGS_OPEN':
    LoggingService.getInstance().debug('APP REDUCER --- TOGGLE_SETTINGS_OPEN');
      return { ...state, isSettingsOpen: action.payload };

    case 'TOGGLE_KEEP_SETTINGS_OPEN':
      LoggingService.getInstance().debug('APP REDUCER --- TOGGLE_KEEP_SETTINGS_OPEN');
      return { ...state, shouldSettingsStayOpen: action.payload };

    case "SHOW_LOGIN":
      LoggingService.getInstance().debug('APP REDUCER --- SHOW_LOGIN');
      //console.log('action payload', action.payload)
      return { ...state,  "credentials": objectMerge(state.credentials, action.payload) };

    case "LOGOUT":
      {
        LoggingService.getInstance().debug('APP REDUCER --- LOGOUT');
        const newCreds = { ...state.credentials};
        //remove these from creds when I logout
        delete newCreds.pwd;
        delete newCreds.hash;
        delete newCreds.isAutoLogin;
        delete newCreds.autologin;

        return { ...state,  "credentials": newCreds  };
      }

    case 'AUTH_SUBMIT_LOGIN':
      LoggingService.getInstance().debug('APP REDUCER --- AUTH_SUBMIT_LOGIN');
      LoggingService.getInstance().debug('auth submit login: ', action.payload)
      //if (localStorage) {
        //save it
        //action.payload.autologin = true;
        const saveData = { ...action.payload };
        // hash pwd
        if (saveData.pwd){
          saveData.hash = crypto.createHash('sha1').update(saveData.pwd).digest('hex');
        }
        //autologin
        saveData.autologin = saveData.remember;

        // Since need to authenticate to identity service, need to retain pwd... so don't delete
        // delete saveData.pwd;

        LocalStorageService.setData('credentials', saveData);
      //}
      // fix credentials
      delete saveData.settings;
      return { ...state, "credentials": objectMerge(state.credentials, saveData)};

    case "LOGIN_FAILED":
      LoggingService.getInstance().debug('APP REDUCER --- LOGIN_FAILED');
      const newState = objectMerge({}, state);
      // since login failed, clear the credentials
      return { ...newState, "credentials": {}};

    case 'EXPIRED_PASSWORD':
      LoggingService.getInstance().debug('APP REDUCER --- EXPIRED_PASSWORD');
      return { ...state, "credentials": objectMerge(state.credentials, action.payload)};

    case 'CONNECTED':
      LoggingService.getInstance().debug('APP REDUCER --- CONNECTED');
      return { ...state, "status": action.payload  };

    case 'ATTENDED_TRANSFER':
      LoggingService.getInstance().debug('APP REDUCER --- ATTENDED_TRANSFER');
      return {...state, transferCallId: action.payload.transferCallId};

    case 'CLEANUP_ATTENDED_TRANSFER':
    {
      LoggingService.getInstance().debug('APP REDUCER --- CLEANUP_ATTENDED_TRANSFER');
      // if there are more that 2 calls in inprogressCalls, then there will
      // be an active call after the transfer completes.
      LoggingService.getInstance().debug('###### cleanup attended transfer ', state.transferCallId);
      let newState = {...state};
      delete newState.transferCallId;
      return newState;
    }

    case "CHANGE_SETTINGS_MENU":
    {
      const newState = objectMerge({}, state);
      LoggingService.getInstance().info("SETTING CLICK", action.payload);
      newState.currentSettingsCategory = action.payload.currentSettingsCategory;
      return newState;
    }

    case 'APP_SHOW_DTMF':
      LoggingService.getInstance().debug('APP REDUCER --- APP_SHOW_DTMF');
      return {...state, showDTMFKeypad: action.payload};

    case 'APP_SHOW_ADD_CALL_KEYPAD':
      LoggingService.getInstance().debug('APP REDUCER --- APP_SHOW_DTMF');
      return {...state, showAddCallKeypad: action.payload};

    case 'SETTINGS_UPDATE_DEFERMENT':
      LoggingService.getInstance().debug('APP REDUCER --- SETTINGS_UPDATE_DEFERMENT');
      return { ...state, isSettingsPendingUpdate: true};

    case 'PROCESS_DEFERRED_SETTINGS_UPDATE':
      LoggingService.getInstance().debug('APP REDUCER --- PROCESS_DEFERRED_SETTINGS_UPDATE');
      return { ...state, isSettingsPendingUpdate: false};

    case 'APP_SET_UI_THEME':
      LoggingService.getInstance().debug('APP REDUCER --- APP_SET_UI_THEME');
      return { ...state, uiTheme: action.payload};

    case 'APP_SET_LANGUAGE':
      LoggingService.getInstance().debug('APP REDUCER --- APP_SET_LANGUAGE');
      return { ...state, localeData: action.payload};

    case 'SET_USER_MENU_OPEN':
      LoggingService.getInstance().debug('APP REDUCER --- SET_USER_MENU_OPEN');
      return { ...state, isUserMenuOpen: action.payload};

    case 'SET_CURRENT_CONTACT':
      return { ...state, currentContact : action.payload};

    default:
      return state;
  }
};

export { app };



// WEBPACK FOOTER //
// ./src/reducers/app-reducers.js